// TRADE-1009: drag-vs-tap detection for the floating AI-chat toggle. Its own
// module (no markdown/chart imports from AIChat.js) so it stays unit-testable.

// Minimum pointer travel (px) before an interaction counts as a drag.
export const DRAG_THRESHOLD_PX = 5;

// `start`/`stop` are react-draggable { x, y } positions from onStart/onStop;
// true only if the pointer moved beyond `threshold`.
export const isDragGesture = (start, stop, threshold = DRAG_THRESHOLD_PX) => {
  if (!start || !stop) return false;
  const dx = (stop.x ?? 0) - (start.x ?? 0);
  const dy = (stop.y ?? 0) - (start.y ?? 0);
  return Math.hypot(dx, dy) > threshold;
};
